export default $axios => ({
  resource: 'moraine/occupation'
})
